import React, { Suspense } from 'react';

import { LinearProgress } from '../linear-progress/linear-progress';

import type { IWysiwygEditorContentProps } from './wysiwyg-editor-yfm-content';
import styles from './wysiwyg-editor-yfm.module.scss';

const WysiwygEditorContent = React.lazy(() => import('./wysiwyg-editor-yfm-content'));

export const WysiwygEditor: React.FC<IWysiwygEditorContentProps> = (props) => {
    return (
        <Suspense fallback={<LinearProgress className={styles.loader}/>}>
            <WysiwygEditorContent {...props} />
        </Suspense>
    );
};
